/* Efectos del rediseño AUGA: reveals con blur + contadores. */
(function(){
  "use strict";
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(){
    var els = document.querySelectorAll('[data-creveal]:not([data-creveal-on])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)){
      els.forEach(function(e){ e.setAttribute('data-creveal-on','1'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){
          en.target.setAttribute('data-creveal-on','1');
          io.unobserve(en.target);
        }
      });
    }, {threshold:.12, rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){
      var hijos = e.hasAttribute('data-creveal-stagger');
      if (hijos) Array.prototype.forEach.call(e.children, function(c,i){
        c.style.setProperty('--ci', i);
      });
      io.observe(e);
    });
  }

  function initCounters(){
    var els = document.querySelectorAll('[data-ccount]:not([data-ccount-on])');
    if (!els.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        el.setAttribute('data-ccount-on','1');
        var target = parseFloat(el.getAttribute('data-ccount'));
        var dec = parseInt(el.getAttribute('data-cdec')||'0',10);
        var pre = el.getAttribute('data-cpre')||'', suf = el.getAttribute('data-csuf')||'';
        if (reduce){ el.textContent = pre + target.toLocaleString('es-MX',{minimumFractionDigits:dec,maximumFractionDigits:dec}) + suf; return; }
        var t0 = performance.now();
        (function step(now){
          var k = Math.min(1,(now-t0)/1400); k = 1-Math.pow(1-k,4);
          el.textContent = pre + (target*k).toLocaleString('es-MX',{minimumFractionDigits:dec,maximumFractionDigits:dec}) + suf;
          if (k<1) requestAnimationFrame(step);
        })(t0);
      });
    },{threshold:.6});
    els.forEach(function(e){ io.observe(e); });
  }

  function boot(){ initReveals(); initCounters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
